import { render, staticRenderFns } from "./S3_P2_Failed.vue?vue&type=template&id=6bafbde0&scoped=true&"
import script from "./S3_P2_Failed.vue?vue&type=script&lang=js&"
export * from "./S3_P2_Failed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bafbde0",
  null
  
)

export default component.exports